import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/images/logo.jpg";
import axios from "axios";
import { Eye, EyeOff } from "lucide-react";
import { toast, Toaster } from "react-hot-toast";
import CheckLoginRedirect from "../components/CheckLoginRedirect";
import config from "../config";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null); // 👈 profile state

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      toast.error("Please fill in all fields");
      return;
    }

    setLoading(true);

    try {
      const res = await axios.post(
        `${config.API_BASE_URL}/api/auth/login`,
        { email, password },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const { user, token } = res.data;

      console.log("🔍 Login Response - User:", user);
      console.log("🔍 Login Response - Token:", token ? "Exists" : "Missing");
      console.log(
        "🔍 Login Response - Token length:",
        token ? token.length : 0
      );

      if (user && token) {
        if (!user.isVerified) {
          toast.error("Your account is not verified. Check your email.");
          return navigate("/verify-email");
        }

        // ✅ Store token
        localStorage.setItem("authToken", token);
        console.log("✅ Token stored in localStorage");

        // ✅ Redirect based on role
        navigate(user.role === "admin" ? "/admin/dashboard" : "/dashboard");
      } else {
        console.error("❌ No token received from backend");
        toast.error("Login failed - no authentication token received");
      }
    } catch (err) {
      console.error("❌ Login error:", err);
      toast.error(err.response?.data?.error || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      {/* <CheckLoginRedirect /> */}
      {/* Hot-toast container */}
      <Toaster position="top-center" />

      <div className="w-full max-w-md bg-white shadow-lg rounded-2xl p-8">
        {/* Logo */}
        <div className="flex justify-center mb-4">
          <img
            src={logo}
            alt="Company Logo"
            className="h-16 w-16 object-cover rounded-full"
          />
        </div>

        <h1 className="text-3xl font-bold text-center mb-6 text-[#007AFF]">
          Login
        </h1>

        <form onSubmit={handleLogin} className="space-y-6">
          {/* Email */}
          <div>
            <label className="block text-gray-700 font-medium mb-2">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#007AFF] outline-none"
            />
          </div>

          {/* Password */}
          <div>
            <label className="block text-gray-700 font-medium mb-2">
              Password
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#007AFF] outline-none pr-10"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>
          </div>

          {/* Forgot Password */}
          <div className="flex justify-between items-center text-sm">
            <Link
              to="/ForgotPassword"
              className="text-[#007AFF] hover:underline"
            >
              Forgot Password?
            </Link>
          </div>

          {/* Submit */}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#007AFF] text-white py-3 rounded-lg font-semibold hover:bg-blue-600 transition disabled:opacity-50"
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        {/* Signup link */}
        <p className="mt-6 text-center text-gray-600">
          Don’t have an account?{" "}
          <Link to="/signup" className="text-[#007AFF] hover:underline">
            Sign Up
          </Link>
        </p>
      </div>
    </div>
  );
}
